class BESSAppProjectsItem extends BESSAppBase {

    constructor(node) {
        super();
        this.node = node;
        this.projectId = this.node.data('project-id');
        this.projectName = this.node.find('.app-project-name').text().trim();
        this.mapItem = this.node.find('.project-map');

        let lat = parseFloat(this.mapItem.data('lat'));
        let lng = parseFloat(this.mapItem.data('lng'));
        if (!isNaN(lat) && !isNaN(lng)) {
            let latlng = new google.maps.LatLng(lat, lng);

            BESSSetupMapComponent(this.mapItem, latlng, 12);
        }

        this.deleteBtn = this.node.find('.app-project-delete');
        this.deleteBtn.bindClickEvent(this, this.#onDeleteProject);

        this.recalculateBtn = this.node.find('.app-project-recalculate');
        this.recalculateBtn.bindClickEvent(this, this.#onProjectRecalculate);

    }

    #onDeleteProject(e) {
        let target = $(e.target);
        let projectId = target.attr('data-project-id');

        if (target.hasClass('app-project-delete-version')) {
            let version = target.attr('data-version');
            this.askUserToConfirmSeriousOperation('Delete Project: ' + this.projectName + ", version \"" + version + "\"",
                'Are you sure you wish to delete this project version? Once you hit delete, you will no longer have access to this version or any files you’ve uploaded to this version. There is no undo.',
                function () {
                    this.#onDeleteConfirmed(projectId, version)
                }.bind(this),
                'Yes - Delete project version',
                'Cancel',
                null,
            );
        } else {

            this.askUserToConfirmSeriousOperation('Delete Project: ' + this.projectName,
                'Are you sure you wish to delete this project? Once you hit delete, you will no longer have access to this project or any files you’ve uploaded to this project. There is no undo.',
                function () {
                    this.#onDeleteConfirmed(projectId)
                }.bind(this),
                'Yes - Delete project',
                'Cancel',
                null,
            );
        }
    }

    #onDeleteConfirmed(projectId, version = null) {
        if (version != null) {
            this.showDoingWork('Delete Project: ' + this.projectName + version, 'Deleting project version...')
        } else {
            this.showDoingWork('Delete Project: ' + this.projectName, 'Deleting project...')
        }
        BESSApp.instance.services.api.projects.apiDelete(projectId, this.#onDeleteProcessed.bind(this));
    }

    #onDeleteProcessed() {
        window.location.reload();
    }

    #onProjectRecalculate(e) {
        let target = $(e.target);
        let projectId = target.attr('data-project-id');
        this.recalculateBtn.disableControl();
        BESSApp.instance.services.api.projects.apiRecalculate(projectId, function () {
            this.#onProjectRecalculating(projectId)
        }.bind(this))
    }

    #onProjectRecalculating(projectId) {
        window.location.href = '/app/project/' + projectId;
    }
}
